import { Box } from '@cp/ds/src/components/box';
import { Breadcrumbs } from '@cp/ds/src/components/breadcrumbs';
import { Container } from '@cp/ds/src/components/container';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteConfigComponentProps } from 'react-router-config';
import { usePathGenerator } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { RoutedLink as Link, RoutedLink } from 'src/shared/ui/link';
import Header from 'src/widgets/header';
import { SupportSocialMediaContacts } from 'src/widgets/support';

const SupportPage: React.FC<RouteConfigComponentProps> = () => {
  const generateAppPath = usePathGenerator();

  return (
    <Box>
      <Helmet>
        <title>Связаться с нами - YouHelp.ru</title>
        <meta content="Напишите в техподдержку Юхелп.ру - форма обратной связи." name="description" />
      </Helmet>

      <Header />

      <Container sx={{ pb: { xs: 6, md: 20 } }}>
        <Breadcrumbs
          LinkComponent={RoutedLink}
          items={[
            {
              path: '/',
              label: 'Главная',
            },
            {
              path: '',
              label: 'Связаться с нами',
            },
          ]}
          sx={{ my: 2 }}
        />
        <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, m: 0, mb: { xs: 4, md: 7 } }}>
          Связаться с нами
        </Typography>
        <SupportSocialMediaContacts />
        <Stack>
          <Link href={`${generateAppPath({ page: ClientWebPage.FAQ })}#helper-faq`}>Ответы на вопросы работников</Link>
          <Link href={`${generateAppPath({ page: ClientWebPage.FAQ })}#client-faq`}>Ответы на вопросы нанимателей</Link>
        </Stack>
      </Container>
    </Box>
  );
};

export default SupportPage;
